import React from 'react'
import PropTypes from 'prop-types'
import trans from 'counterpart'
import { connect } from 'react-redux'
import moment from 'moment'
import Image from '../../media/components/Image'
import TravelCompanySummary from '../../booking/components/TravelCompanySummary'
import {
  reservationSelector,
  resourceInReservationSelector
} from '../selectors'
import { DISPLAY_DATE_WITH_DAY } from '../../../constants/dates'

const StayInfoReceipt = ({ reservation, resource, properties, manageTags }) => (
  <div className='stay-info-receipt' {...manageTags}>
    {reservation.resort_id && reservation.resort_id === 2041 && (
      <label className='label-srbb bg-red-light text-white font-weight-bold'>
        <i className='libema-icons'>&#xE910;</i>
        {trans('resort.safari_resort')}
      </label>
    )}

    {reservation.resort_id && reservation.resort_id === 21 && (
      <label className='label-vpbb bg-orange-light text-white font-weight-bold'>
        <i className='libema-icons'></i>
        {trans('resort.vakantiepark')}
      </label>
    )}

    {resource && resource.images.length > 0 && (
      <Image
        file={resource.images[0].reference}
        filter='md_43'
        attr={{
          className: 'card-img-top img-fluid',
          alt: resource.display_name
        }}
      />
    )}
    {resource && <h5 className='text-lato text-info mb-0 pt-1 px-1'>{trans('label.your_booking')}</h5>}
    <TravelCompanySummary properties={properties} />
    <ul className='list-unstyled mb-0 p-1'>
      <li className='row'>
        <div className='col-4'>{trans('stay.arrival')}</div>
        <div className='col-8 col-md-7 offset-md-1'>
          {moment(reservation.arrival_date).utcOffset(2).format(DISPLAY_DATE_WITH_DAY)}
        </div>
      </li>
      <li className='row'>
        <div className='col-4'>{trans('stay.departure')}</div>
        <div className='col-8 col-md-7 offset-md-1'>
          {moment(reservation.departure_date).utcOffset(2).format(DISPLAY_DATE_WITH_DAY)}
        </div>
      </li>
      <li className='row'>
        <div className='col-4'>{trans('stay.label')}</div>
        <div className='col-8 col-md-7 offset-md-1'>
          {`${reservation.criteria.duration} ${trans('stay.nights')}`}
        </div>
      </li>
    </ul>
  </div>
)

const StayInfo = ({ reservation, resource, manageTags }) => (
  <div {...manageTags}>
    <h4 className='margin-bottom-1'>{trans('stay.label')}</h4>
    <ul className='list-unstyled mb-0'>
      <li className='row'>
        <div className='col-4 font-italic'>{trans('stay.arrival')}</div>
        <div className='col-8'>
          <strong style={{ display: 'flex' }}>{moment(reservation.arrival_date).utcOffset(2).format('dddd D MMMM YYYY')}</strong>
          {resource && resource.resort.id === 2041 && (
            <span>
              {trans('stay.check_in_resort')}
            </span>
          )}
          {resource && resource.resort.id !== 2041 && (
            <span>
              {[29, 30, 31, 32, 34].indexOf(parseInt(reservation.criteria.resource_id, 10)) !== -1 ? trans('stay.check_in_camping') : trans('stay.check_in')}
            </span>
          )}
        </div>
      </li>
      <li className='row'>
        <div className='col-4 font-italic'>{trans('stay.departure')}</div>
        <div className='col-8'>
          <strong>{moment(reservation.departure_date).utcOffset(2).format('dddd D MMMM YYYY')}</strong>
          <br />
          <span>
            {[29, 30, 31, 32, 34].includes(parseInt(reservation.criteria.resource_id, 10)) ? trans('stay.check_out_camping') : trans('stay.check_out')}
          </span>
        </div>
      </li>
      <li className='row'>
        <div className='col-4 font-italic'>{trans('stay.label')}</div>
        <div className='col-8'>
          <strong>
            {`${reservation.criteria.duration} ${trans('stay.nights')}`}
          </strong>
        </div>
      </li>
    </ul>
  </div>
)

StayInfo.propTypes = {
  reservation: PropTypes.object,
  resource: PropTypes.object
}

StayInfoReceipt.propTypes = {
  properties: PropTypes.oneOfType([PropTypes.array, PropTypes.object]), // Might be of type array when empty
  reservation: PropTypes.object,
  resource: PropTypes.object
}

const StayInfoWrapper = ({ properties, ...rest }) => (
  <>
    {properties.template === 'receipt' && <StayInfoReceipt properties={properties} {...rest} />}
    {properties.template !== 'receipt' && <StayInfo {...rest} />}
  </>
)

StayInfoWrapper.propTypes = {
  properties: PropTypes.oneOfType([PropTypes.array, PropTypes.object]), // Might be of type array when empty
  reservation: PropTypes.object,
  resource: PropTypes.object
}

const mapStateToProps = state => ({
  reservation: reservationSelector(state),
  resource: resourceInReservationSelector(state),
  locale: state.preferences.locale
})

export default connect(mapStateToProps)(StayInfoWrapper)
